import { AccessPointService } from './../../../../services/access-controler/access-point.service';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Customer } from 'src/app/models';

@Component({
  selector: 'app-customer-catracas',
  templateUrl: './customer-catracas.component.html',
  styleUrls: ['./customer-catracas.component.scss'],
})
export class CustomerCatracasComponent implements OnInit {
  userToIntegration: any;
  integrarType: string;
  removeCatracas: boolean;
  hasDependents: boolean = false;

  points: any[] = [];
  constructor(
    public dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private AccessPointService: AccessPointService
  ) {}

  ngOnInit(): void {
    if (this.config.data) {
      if (this.config.data.removeCatracas) {
        this.removeCatracas = true;
      }

      if (this.config.data.customer != null) {
        this.integrarType = 'customer';
        this.userToIntegration = this.config.data.customer;
        const mainCustomer = this.userToIntegration;
        (mainCustomer.catracas || []).forEach((catraca) => {
          this.points.push({
            catraca,
            status: null,
            customerId: mainCustomer.id,
            colectId: mainCustomer.colectId,
            customerName: mainCustomer.name,
          });
        });

        const dependentsCatracas = this.config.data.dependentsCatracas || [];
        if (dependentsCatracas.length > 0) {
          this.hasDependents = true;
        }
        dependentsCatracas.forEach((dependent: any) => {
          (dependent.catracas || []).forEach((catraca: any) => {
            this.points.push({
              catraca,
              status: null,
              customerId: dependent.id,
              colectId: dependent.colectId,
              customerName: dependent.name,
            });
          });
        });

        this.integrar();
      }
      if (this.config.data.sailor && this.config.data.sailor.catracas != null) {
        this.integrarType = 'sailor';
        this.userToIntegration = this.config.data.sailor;
        this.userToIntegration.catracas.forEach((catraca) => {
          this.points.push({
            catraca,
            status: null,
            customerId: this.userToIntegration.id,
            colectId: this.userToIntegration.colectId,
            customerName: this.userToIntegration.name,
          });
        });
        this.integrar();
      }
    }

  }

  integrar() {
    this.points.forEach((point) => this.executePoint(point));
  }

  fechar() {
    this.dialogRef.close(this.points);
  }

  reenviar(point) {
    point.status = null;
    this.executePoint(point);
  }

  private executePoint(point: any): void {
    if (this.removeCatracas) {
      this.AccessPointService.removerCatraca({
        accessPoint: point.catraca,
        userId: point.colectId,
        typeRegister: this.integrarType,
      }).subscribe((data) => {
        point.status = data;
      });
    } else {
      this.AccessPointService.ingetracaoCatraca({
        accessPoint: point.catraca,
        userId: point.customerId,
        typeRegister: this.integrarType,
      }).subscribe((data) => {
        point.status = data;
      });
    }
  }
}
